import request from "@/http";
/**
 * 案例banner
 * @returns
 */
const getCaseBanner = (data) => {
    let { length_4_list = 10, isloading = false } = data;
    return request.get({
        url: "duzikai_api_mgr_public_front_page",
        data: {
            invoke_method: "public_page_4m_load_page_list",
            pre_db_para_begin_idx:0,
            pre_db_para_length_4_list:length_4_list,
            type_page_front: 1,
            id_public_agent_info: 99101,
            is_online: 0
        },
        loading: {
            enabled: isloading
        }
    });
}

/**
 * 案例列表
 * @param {索引} idx
 * @param {每页显示数} limit
 * @param {类型：301:平台交易类，302:业务管理类，303:业务应用类} type
 * @returns
 */
const getCaseList = (data) => {
        let { idx, limit, type, id_public_goods_type, id_public_agent_info, goods_info_remark_005 = 501, isloading = false } = data;
        return request.get({
            url: "duzikai_api_mgr_public_goods_info",
            data: {
                invoke_method: "public_page_4m_shop_goods_list_2_reg",
                id_public_goods_type: 199,
                type_child: 200,
                pre_db_para_begin_idx: idx,
                pre_db_para_length_4_list: limit,
                'public_goods_supply_4_shop.buyer_id': 99101,
                pre_db_spec_buyer_id: 99101,
                'public_goods_supply_4_shop.id_public_goods_supply_4_shop_is_not_null': true,
                goods_info_remark_003: type,
                goods_info_remark_005: goods_info_remark_005,
                pre_db_para_order_by_para:'data_weight DESC'
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 案例详情
     * @param {案例id} id
     * @param {用户id} seller_id
     * @returns
     */
const getCaseDetail = (data) => {
        let { id, seller_id, isloading = false } = data;
        return request.get({
            url: "duzikai_api_customer_public_goods_mgr",
            data: {
                invoke_method: "show_goods_info",
                id_public_goods_info: id,
                seller_id: seller_id
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 收藏案例/取消收藏
     * @param {用户id} uid
     * @param {案例id}} caseid
     * @returns
     */
const collectCase = (data) => {
        let { id_public_user_info,id_public_goods_info, isloading = false } = data;
        console.log(data)
        return request.post({
            url: "duzikai_api_mgr_public_middle_table",
            data: {
                invoke_method:'public_insert_or_update_middle_table',
                pre_db_para_middle_table_name:'public_middle_table_20004',
                type_middle_app:20004,
                type_inner_app:1001,
                id_public_user_info: id_public_user_info,
                id_public_goods_info: id_public_goods_info,
                is_online:0
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 收藏案例/取消收藏
     * @param {用户id} uid
     * @param {案例id}} caseid
     * @returns
     */
const delCollectCase = (data) => {
        let { id_public_middle_table, isloading = false } = data;
        return request.post({
            url: "duzikai_api_mgr_public_middle_table",
            data: {
                invoke_method:'public_insert_or_update_middle_table',
                pre_db_para_middle_table_name:'public_middle_table_20004',
                type_middle_app:20004,
                type_inner_app:1001,
                pre_db_para_id_public_middle_table: id_public_middle_table,
                is_online:1
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 修改完善申请资料
     * @returns
     */
const numChange = (data) => {
        let { id_public_goods_order_record, order_detail_change_data, isloading = false } = data;
        return request.post({
            url: "duzikai_api_customer_public_order_mgr",
            data: {
                invoke_method: "num_change_order_details",
                id_public_goods_order_record: id_public_goods_order_record,
                pre_cmd_para_order_detail_change_data: order_detail_change_data,
                opt_type: 0,
                seller_id: 300098 //99101
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 调用pre_submit接口, 将申请时的字段传入
     * @returns
     */
const preSubmit = (data) => {
        let {
            id_public_goods_order_record,
            phone_user,
            receive_name,
            append_order_remark_004,
            append_order_remark_005,
            append_order_remark_006,
            append_order_remark_007,
            append_order_remark_008,
            append_order_remark_009,
            isloading = false
        } = data;
        return request.post({
            url: "duzikai_api_customer_public_order_mgr",
            data: {
                invoke_method: "pre_submit_4_order",
                pre_db_para_id_public_goods_order_record: id_public_goods_order_record,
                ways_of_payment: 2111,
                phone_user: phone_user,
                receive_name: receive_name,
                append_order_remark_004: append_order_remark_004,
                append_order_remark_005: append_order_remark_005,
                append_order_remark_006: append_order_remark_006,
                append_order_remark_007: append_order_remark_007,
                append_order_remark_008: append_order_remark_008,
                append_order_remark_009: append_order_remark_009,
                type_order_4_application: 100001
                // ship_state: ship_state
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     * 删除我的申请
     * @param {*} id_public_goods_order_record
     * @param {*} ship_state
     * @param {*} isloading
     * @returns
     */
const delMyApply = (data) => {
        let { id_public_goods_order_record,buyer_id, ship_state, isloading = false } = data;
        return request.post({
            url: "duzikai_api_customer_public_order_mgr",
            data: {
                invoke_method: "pre_submit_4_order",
                pre_db_para_id_public_goods_order_record: id_public_goods_order_record,
                ship_state: ship_state,
                buyer_id: buyer_id
            },
            loading: {
                enabled: isloading
            }
        });

    }
    /**
     * 调用非第三方支付接口完成申请
     * @returns
     */
const pay = (data) => {
    let { id_public_goods_order_record, isloading = false } = data;
    return request.post({
        url: "duzikai_api_customer_public_order_mgr",
        data: {
            invoke_method: "user_pay_4_order_no_third_party",
            id_public_goods_order_record: id_public_goods_order_record,
        },
        loading: {
            enabled: isloading
        }
    });
}
const orderDetail = (data) => {
        let { id_public_goods_order_record, isloading = false } = data;
        return request.get({
            url: "duzikai_api_customer_public_order_mgr",
            data: {
                invoke_method: "details_4_order",
                id_public_goods_order_record: id_public_goods_order_record
            },
            loading: {
                enabled: isloading
            }
        })
    }
    /**
     * 我的申请
     * @param {索引} idx
     * @param {每页显示数} limit
     * @returns
     */
const myApply = (data) => {
        let { idx, limit,buyer_id, isloading = false } = data;
        return request.get({
            url: "duzikai_api_mgr_public_user_info",
            data: {
                invoke_method: 'public_page_4m_user_order_4_balance',
                pre_db_para_begin_idx: idx,
                pre_db_para_length_4_list: limit,
                type_order: '1,4',
                buyer_id: buyer_id,
                type_order_4_application: 100001,
                pre_db_para_order_by_para: ' time_order desc ',
            },
            loading: {
                enabled: isloading
            }
        });
    }
    /**
     *
     * @param {索引} idx
     * @param {每页显示数} limit
     * @param {用户id} id_public_user_info
     * @returns
     */
const myCollect = (data) => {
    let { idx, limit, id_public_user_info, isloading = false } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: 20004,
            type_inner_app: 1001,
            pre_db_para_middle_table_name: "public_middle_table_20004",
            id_public_user_info: id_public_user_info,
            is_online: 0
        },
        loading: {
            enabled: isloading
        }
    });
}


const applyTaste = (data) => {
    let { id_public_user_info,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004, isloading = false } = data;
    console.log(data)
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method:'public_insert_or_update_middle_table',
            pre_db_para_middle_table_name:'public_middle_table',
            type_middle_app:65001,
            type_inner_app:20002,
            mid_table_remark_001: mid_table_remark_001,
            mid_table_remark_002: mid_table_remark_002,
            mid_table_remark_003: mid_table_remark_003,
            mid_table_remark_004: mid_table_remark_004,
            is_online:0
        },
        loading: {
            enabled: isloading
        }
    });
}


export default {
    getCaseBanner,
    getCaseList,
    getCaseDetail,
    collectCase,
    delCollectCase,
    numChange,
    preSubmit,
    delMyApply,
    pay,
    orderDetail,
    myApply,
    myCollect,
    applyTaste
}
